export default __webpack_public_path__ + "static/encode-8ca15716a400de6c5ed1d298003289ca.svg";